import { render, staticRenderFns } from "./LandingPageWhatsapp.vue?vue&type=template&id=b49047ae&"
import script from "./LandingPageWhatsapp.vue?vue&type=script&lang=js&"
export * from "./LandingPageWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports